import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "框架",
  "description": "将你最喜欢的框架集成到 Turborepo。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 可与任何框架兼容。下面，你将找到与 Turborepo 一起使用的最常见框架的指南。"
  }, {
    "heading": "",
    "content": "¥Turborepo works with any framework. Below, you'll find guides for the most common frameworks being used with Turborepo."
  }],
  "headings": []
};
import {Cards, Card} from '#components/card';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Turborepo 可与任何框架兼容。下面，你将找到与 Turborepo 一起使用的最常见框架的指南。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo works with ", _jsx(_components.strong, {
        children: "any framework"
      }), ". Below, you'll find guides for the most common frameworks being used with Turborepo."]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "Next.js",
        href: "/docs/guides/frameworks/nextjs"
      }), _jsx(Card, {
        title: "SvelteKit",
        href: "/docs/guides/frameworks/sveltekit"
      }), _jsx(Card, {
        title: "Vite",
        href: "/docs/guides/frameworks/vite"
      }), _jsx(Card, {
        title: "Nuxt",
        href: "/docs/guides/frameworks/nuxt"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
